import BigNumber from 'bignumber.js';
import bowser from 'bowser';

function getNetwork(provider) {
  return new Promise(function (resolve, reject) {
    provider.sendAsync({
      method: 'net_version',
      params: [],
      id: 42
    }, function (e, res) {
      e && reject(e);
      resolve(Number(res && res.result));
    });
  });
}

function getAddress(provider) {
  return new Promise(function (resolve, reject) {
    provider.sendAsync({
      method: 'eth_accounts',
      params: [],
      id: 42
    }, function (e, res) {
      e && reject(e);
      resolve(res && res.result && res.result[0]);
    });
  });
}

function getBalance(provider) {
  return new Promise(function _callee(resolve, reject) {
    var currentAddress;
    return regeneratorRuntime.async(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return regeneratorRuntime.awrap(getAddress(provider));

          case 2:
            currentAddress = _context.sent;

            if (currentAddress) {
              _context.next = 6;
              break;
            }

            resolve(null);
            return _context.abrupt("return");

          case 6:
            provider.sendAsync({
              method: 'eth_getBalance',
              params: [currentAddress, 'latest'],
              id: 42
            }, function (e, res) {
              e && reject(e);
              resolve(res && res.result && new BigNumber(res.result).toString(10));
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    });
  });
}

function createModernProviderInterface(provider) {
  provider.autoRefreshOnNetworkChange = false;
  var onFuncExists = typeof provider.on === 'function';
  return {
    address: onFuncExists ? {
      onChange: function onChange(func) {
        // get the initial value
        getAddress(provider).then(func);
        provider.on('accountsChanged', function (accounts) {
          return func(accounts[0]);
        });
      }
    } : {
      get: function get() {
        return getAddress(provider);
      }
    },
    network: onFuncExists ? {
      onChange: function onChange(func) {
        // get initial value
        getNetwork(provider).then(func);
        provider.on('networkChanged', func);
      }
    } : {
      get: function get() {
        return getNetwork(provider);
      }
    },
    balance: {
      get: function get() {
        return getBalance(provider);
      }
    },
    connect: function connect() {
      return new Promise(function (resolve, reject) {
        provider.enable().then(resolve)["catch"](function () {
          return reject({
            message: 'This dapp needs access to your account information.'
          });
        });
      });
    },
    name: getProviderName(provider)
  };
}

function createLegacyProviderInterface(provider) {
  return {
    address: {
      get: function get() {
        return getAddress(provider);
      }
    },
    network: {
      get: function get() {
        return getNetwork(provider);
      }
    },
    balance: {
      get: function get() {
        return getBalance(provider);
      }
    },
    name: getProviderName(provider)
  };
}

function getProviderName(provider) {
  if (!provider) return;

  if (provider.isMetaMask) {
    return 'MetaMask';
  }

  if (provider.isDapper) {
    return 'Dapper';
  }

  if (provider.isWalletConnect) {
    return 'WalletConnect';
  }

  if (provider.isTrust) {
    return 'Trust';
  }

  if (provider.isCoinbaseWallet) {
    return 'Coinbase';
  }

  if (provider.isToshi) {
    return 'Toshi';
  }

  if (provider.isCipher) {
    return 'Cipher';
  }

  if (provider.isOpera) {
    return 'Opera';
  }

  if (provider.host && provider.host.indexOf('localhost') !== -1) {
    return 'localhost';
  }
}

function getDeviceInfo() {
  var browser = bowser.getParser(window.navigator.userAgent);

  var _browser$getOS = browser.getOS(),
      name = _browser$getOS.name;

  var _browser$getPlatform = browser.getPlatform(),
      type = _browser$getPlatform.type;

  return {
    isMobile: type !== 'desktop',
    os: name
  };
}

function networkName(id) {
  switch (id) {
    case 1:
      return 'mainnet';

    case 3:
      return 'ropsten';

    case 4:
      return 'rinkeby';

    case 5:
      return 'goerli';

    case 42:
      return 'kovan';

    default:
      return 'local';
  }
}

function networkToId(network) {
  switch (network) {
    case 'mainnet':
      return 1;

    case 'ropsten':
      return 3;

    case 'rinkeby':
      return 4;

    case 'goerli':
      return 5;

    case 'kovan':
      return 42;

    default:
      return 0;
  }
}

function wait(time) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, time);
  });
}

function makeCancelable(promise) {
  var rejectFn;
  var wrappedPromise = new Promise(function (resolve, reject) {
    rejectFn = reject;
    promise.then(resolve)["catch"](reject);
  });

  wrappedPromise.cancel = function () {
    rejectFn('poop');
  };

  return wrappedPromise;
}

function isPromise(val) {
  if (val instanceof Promise) {
    return true;
  }

  return false;
}

export { createModernProviderInterface as a, getNetwork as b, createLegacyProviderInterface as c, getAddress as d, getBalance as e, getDeviceInfo as f, getProviderName as g, networkToId as h, isPromise as i, makeCancelable as m, networkName as n, wait as w };